import { render } from "./IndexDropdown.vue?vue&type=template&id=086f094e"
import script from "./IndexDropdown.vue?vue&type=script&lang=js"
export * from "./IndexDropdown.vue?vue&type=script&lang=js"

import exportComponent from "E:\\apps\\cangjieweb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__